export default __webpack_public_path__ + "static/media/microsoftr.d0753ba1.png";